import { render, staticRenderFns } from "./ProductItemDisplay.vue?vue&type=template&id=5318a0ca&scoped=true&"
import script from "./ProductItemDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductItemDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemDisplay.vue?vue&type=style&index=0&id=5318a0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318a0ca",
  null
  
)

export default component.exports